import { render } from "./MovementPage.vue?vue&type=template&id=3653220b"
import script from "./MovementPage.vue?vue&type=script&lang=js"
export * from "./MovementPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__